var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSocDriver(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 30C6.25 18.8041 6.25 13.2062 9.72811 9.72811C13.2062 6.25 18.8041 6.25 30 6.25C41.1959 6.25 46.7938 6.25 50.2719 9.72811C53.75 13.2062 53.75 18.8041 53.75 30C53.75 41.1959 53.75 46.7938 50.2719 50.2719C46.7938 53.75 41.1959 53.75 30 53.75C18.8041 53.75 13.2062 53.75 9.72811 50.2719C6.25 46.7938 6.25 41.1959 6.25 30Z",
    fill: "#03A3E8",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 30C6.25 18.8041 6.25 13.2062 9.72811 9.72811C13.2062 6.25 18.8041 6.25 30 6.25C41.1959 6.25 46.7938 6.25 50.2719 9.72811C53.75 13.2062 53.75 18.8041 53.75 30C53.75 41.1959 53.75 46.7938 50.2719 50.2719C46.7938 53.75 41.1959 53.75 30 53.75C18.8041 53.75 13.2062 53.75 9.72811 50.2719C6.25 46.7938 6.25 41.1959 6.25 30Z",
    stroke: "#1EF5DF",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2385 23.75C36.2385 27.2018 33.4363 30 29.9796 30C26.5229 30 23.7207 27.2018 23.7207 23.75C23.7207 20.2982 26.5229 17.5 29.9796 17.5C33.4363 17.5 36.2385 20.2982 36.2385 23.75Z",
    fill: "#0A2838",
    stroke: "#87FF0B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 42.5C24.5793 36.3946 35.3581 36.1071 41.25 42.5M36.2377 23.75C36.2377 27.2018 33.4355 30 29.9788 30C26.5221 30 23.7199 27.2018 23.7199 23.75C23.7199 20.2982 26.5221 17.5 29.9788 17.5C33.4355 17.5 36.2377 20.2982 36.2377 23.75Z",
    stroke: "#87FF0B",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocDriver);
export default __webpack_public_path__ + "static/media/ic_soc_driver.26dbe65382792ee5204589cfbdc98542.svg";
export { ForwardRef as ReactComponent };